/* Preserve native selection, quantity, cart and modal behavior. */
(() => {
  if (window.__sjNativeQuickViewPolish) return;
  window.__sjNativeQuickViewPolish = true;
  let observedRoot;
  const mount = () => {
    const root = document.getElementById('quickview-product-content');
    if (!root) return;
    if (observedRoot !== root) {
      observedRoot = root;
      // Delegate to native labels, preserving family navigation and option values.
      root.addEventListener('keydown', event => {
        const label = event.target.closest('label.sj-family-toned-option');
        if (label && (event.key === 'Enter' || event.key === ' ') && !event.repeat) {
          event.preventDefault();
          label.click();
        }
      });
      new MutationObserver(mount).observe(root, { childList: true, subtree: true });
    }
    root.querySelectorAll('fieldset[data-option-name="bracelet-length"]').forEach(fieldset => {
      const legend = fieldset.querySelector('legend');
      if (!legend || fieldset.querySelector('.sj-quick-add-size-link')) return;
      const link = document.createElement('a');
      link.className = 'sj-quick-add-size-link';
      link.href = '/pages/bracelet-size-guide';
      link.target = '_blank';
      link.rel = 'noopener';
      link.textContent = 'Help me find my size';
      link.setAttribute('aria-label', 'Help me find my size (opens in a new tab)');
      link.addEventListener('click', event => event.stopPropagation());
      legend.parentElement.appendChild(link);
    });
  };
  document.addEventListener('eurus:quickview:loaded', mount);
  document.addEventListener('DOMContentLoaded', mount);
  mount();
})();
